import { gql } from '@apollo/client';

export const METADATA_DISCOVERY = gql`
  query MetadataDiscovery($input: MetadataDiscoveryInput!) {
    metadataDiscovery(input: $input) {
      metadataKeys
      totalRecordsAnalyzed
      executionTimeMs
      analysisStartTime
      analysisEndTime
      communityId
    }
  }
`;
